import { createSlice } from '@reduxjs/toolkit'

const chainSlice = createSlice({
  name: 'chain',
  initialState: {
    chainInfo: null
  },
  reducers: {
    setChainInfo: (state, action) => {
      state.chainInfo = action.payload
    }
  }
})

export const { setChainInfo } = chainSlice.actions
export const selectChainInfo = (state) => state.chain.chainInfo
export default chainSlice.reducer